/**
 * Which neighborhoods have large illustrated map artwork — Asana O2-52.
 *
 * Two different sets of artwork exist, and they are NOT the same illustration:
 *   public/img/pages/nearby-neighborhoods/map-<slug>.png   260x250
 *   public/img/pages/neighborhoods/map-<slug>.jpg          720x506
 *
 * The small PNGs were being shown at every size. On a neighborhood page that
 * slot is 567 CSS px, so on a 2x screen it was asking 260px of artwork to cover
 * 1134 — a quarter of the resolution needed, which is what the ticket reports.
 * The cards use the PNG on phones, where 260px is enough, and the larger JPG
 * from tablet up.
 *
 * THIS LIST EXISTS BECAUSE THE TWO SETS DO NOT COVER THE SAME NEIGHBORHOODS.
 * Four have a PNG and no JPG. A <picture> element does NOT fall back to its
 * <img> when a <source> 404s — it shows a broken image — so the larger source
 * may only be offered for names that actually have one.
 *
 * Regenerate when artwork is added:
 *   ls public/img/pages/neighborhoods/*.jpg | sed 's/.*map-//; s/\.jpg//'
 *
 * Slugs match neighborhoodSnakeCase(name), not the Airtable name.
 */
export const NEIGHBORHOOD_MAP_JPGS = new Set([
    'albany-park-irving-park',
    'andersonville-edgewater',
    'auburn-gresham',
    'austin',
    'avondale',
    'beverly',
    'beverly-morgan-park',
    'bridgeport',
    'bridgeport-back-of-the-yards',
    'bridgeport-chinatown',
    'bridgeport-chinatown-unlabeled',
    'bronzeville',
    'bronzeville-kenwood',
    'chatham-south-shore',
    'chinatown',
    'downtown',
    'east-garfield-park',
    'edgewater',
    'englewood',
    'garfield-park-north-lawndale',
    'hermosa',
    'humboldt-park',
    'hyde-park',
    'hyde-park-woodlawn',
    'lakeview',
    'lakeview-unlabeled',
    'lincoln-park',
    'lincoln-square-ravenswood',
    'little-village-pilsen',
    'logan-square',
    'near-north-side',
    'near-south-side',
    'near-west-side',
    'pullman',
    'rogers-park-west-ridge',
    'rogers-park-west-ridge-unlabeled',
    'south-shore',
    'ukrainian-village-west-town',
    'uptown',
    'woodlawn',
]);

/**
 * Which neighborhoods have the SMALL map artwork.
 *
 * Needed for the same reason as the jpg list, though as of the 2026 artwork
 * drop every LIVE neighborhood has both sizes — Bronzeville / Kenwood and
 * Chinatown were the two that had neither and fell back to
 * /img/pages/map-coming-soon.svg. The lists are still gated rather than
 * assumed: they also carry slugs for retired groupings that no longer match
 * any neighborhood, and a <picture> shows a broken image rather than falling
 * back to its <img> when a <source> 404s.
 *
 * Regenerate when artwork is added:
 *   ls public/img/pages/nearby-neighborhoods/*.png | sed 's/.*map-//; s/\.png//'
 */
export const NEIGHBORHOOD_MAP_PNGS = new Set([
    'albany-park-irving-park',
    'andersonville-edgewater',
    'auburn-gresham',
    'austin',
    'avondale',
    'beverly',
    'beverly-morgan-park',
    'bridgeport',
    'bridgeport-back-of-the-yards',
    'bridgeport-chinatown',
    'bronzeville',
    'bronzeville-kenwood',
    'chatham-south-shore',
    'chinatown',
    'downtown',
    'east-garfield-park',
    'edgewater',
    'englewood',
    'garfield-park',
    'garfield-park-north-lawndale',
    'hermosa',
    'humboldt-park',
    'hyde-park',
    'hyde-park-woodlawn',
    'i-want-to-be-a-floater!',
    'lakeview',
    'lincoln-park',
    'lincoln-square-ravenswood',
    'little-village',
    'little-village-pilsen',
    'logan-square',
    'logan-square-avondale',
    'near-north-side',
    'near-south-side',
    'near-west-side',
    'near-west-side-west-town',
    'north-lawndale',
    'pilsen',
    'pullman',
    'rogers-park',
    'rogers-park-west-ridge',
    'roseland',
    'south-shore',
    'square_beverly-mtgreenwood',
    'ukrainian-village',
    'ukrainian-village-west-town',
    'uptown',
    'uptown-ravenswood',
    'woodlawn',
]);

/** Shown when a neighborhood has no illustrated map in either set. */
export const MAP_PLACEHOLDER = '/img/pages/map-coming-soon.svg';
